import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { BusinessObjectType } from '@core/enums/business-object-type.enum';
import { ROOT_SCOPE_VARIABLES } from '@core/settings/root-scope.settings';
import { DragObjectTypeEnum } from '../../enums/drag-object-type.enum';
import { DayModel } from '../../models/day-model';
import { DriverVehiclePairModel } from '../../models/driver-vehicle-pair.model';
import { OrderDroppedEvent } from '../../models/order-drag-and-drop.model';
import { PlannerDraggingManagerService } from '../../services/planner-draggin-manager.service';

export interface AddNewAbsenceEvent {
  objectType: BusinessObjectType;
  objectId: number;
}

@Component({
  selector: 'empty-day-box',
  standalone: false,
  templateUrl: './empty-day-box.component.html',
  styleUrls: ['./empty-day-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmptyDayBoxComponent {
  isValidDragOver = false;
  dragNotValid = false;
  dragRegionNotValid = false;

  @Output() orderDropped = new EventEmitter<OrderDroppedEvent>;
  @Output() addNewAbsence = new EventEmitter<AddNewAbsenceEvent>;


  @Input() day!: DayModel;
  @Input() driver!: DriverVehiclePairModel;

  businessObjectType = BusinessObjectType;
  PERM = ROOT_SCOPE_VARIABLES.PERMISSIONS.UNAVAILABILITY;

  constructor(private readonly _dragManager: PlannerDraggingManagerService) { }

  onDragEnter($event: DragEvent): void {
    if ($event.dataTransfer) {

      if (this._dragManager.isDraggingShipment($event)) {
        if (this._dragManager.isDragRegionValid($event, DragObjectTypeEnum.SHIPMENT, this.driver.vehicleRegionId)) {
          $event.preventDefault();
          $event.dataTransfer.dropEffect = 'move'
          this.isValidDragOver = true;
        } else {
          $event.dataTransfer.dropEffect = 'none'
          this.dragRegionNotValid = true;
        }
      } else {
        $event.dataTransfer.dropEffect = 'none'
        this.dragNotValid = true;
      }
    }
  }

  onDragOver($event: any) {
    $event.preventDefault();
  }

  onDragLeave(_: any) {
    if (this.isValidDragOver || this.dragNotValid || this.dragRegionNotValid) {
      this.resetDragState();
    }
  }

  onDrop($event: any) {
    const orderDragInfo = this._dragManager.getDragInfo($event, DragObjectTypeEnum.SHIPMENT);
    
    if (orderDragInfo && !(this.dragNotValid || this.dragRegionNotValid)) {
      this.orderDropped.emit({
        dragInfo: orderDragInfo,
        dropInfo: {
          day: this.day,
          driver: this.driver
        }
      });
    }

    this.resetDragState();
  }

  onAddAbsenceClick(objectType: BusinessObjectType, objectId: number): void {
    this.addNewAbsence.emit({ objectType, objectId });
  }

  private resetDragState() {
    this.isValidDragOver = false;
    this.dragNotValid = false;
    this.dragRegionNotValid = false;
  }
}
